@if (loading) {
  <app-page-loader></app-page-loader>
} @else if (!available) {
  <p class="connections__hint">{{ 'pages.settings.connections.unavailable' | translate }}</p>
} @else {
  <div class="container">
    @for (scope of scopes; track scope) {
      <nb-card>
        <nb-card-header>
          <h6>
            <nb-icon [icon]="scope === 'personal' ? 'person-outline' : 'briefcase-outline'"></nb-icon>
            {{ 'pages.settings.connections.' + scope + '.title' | translate }}
          </h6>
        </nb-card-header>
        <nb-card-body>
          <p class="connections__intro">{{ 'pages.settings.connections.' + scope + '.intro' | translate }}</p>

          @if (connection[scope]; as found) {
            @if (found.status === 'connected') {
              <div class="connections__state">
                <div class="connections__main">
                  <span class="connections__name">
                    {{ 'pages.settings.connections.connectedAs' | translate }}
                    {{ account(found) || ('pages.settings.connections.noName' | translate) }}
                  </span>
                  <span class="connections__meta">
                    @if (found.tokenLast4) {
                      {{ 'pages.settings.connections.tokenEnd' | translate: { last4: found.tokenLast4 } }} ·
                    }
                    {{ 'pages.settings.connections.since' | translate: { date: (found.connectedAt | date: 'dd.MM.yyyy') } }}
                  </span>
                </div>
                @if (scope === 'personal' || canManageTenant) {
                  <button
                    nbButton
                    status="basic"
                    class="btn-caution"
                    shape="round"
                    type="button"
                    [nbSpinner]="busy[scope]"
                    [disabled]="busy[scope]"
                    (click)="disconnect(scope)"
                  >
                    {{ 'pages.settings.connections.disconnect' | translate }}
                  </button>
                }
              </div>
            } @else {
              <p class="connections__error" role="alert">{{ 'pages.settings.connections.unreadable' | translate }}</p>
            }
          } @else if (scope === 'tenant' && !canManageTenant) {
            <p class="connections__hint">{{ 'pages.settings.connections.tenant.none' | translate }}</p>
          }

          @if (showForm(scope)) {
            <form class="connections__form" (ngSubmit)="connect(scope)">
              <label class="label" [for]="'figma-token-' + scope">{{ 'pages.settings.connections.tokenLabel' | translate }}</label>
              <div class="connections__row">
                <input
                  nbInput
                  fullWidth
                  shape="round"
                  type="password"
                  autocomplete="off"
                  spellcheck="false"
                  [id]="'figma-token-' + scope"
                  [name]="'token-' + scope"
                  [placeholder]="'pages.settings.connections.tokenPlaceholder' | translate"
                  [(ngModel)]="token[scope]"
                />
                <button nbButton status="primary" shape="round" type="submit" [nbSpinner]="busy[scope]" [disabled]="busy[scope]">
                  {{ 'pages.settings.connections.connect' | translate }}
                </button>
              </div>
              @if (error[scope]; as key) {
                <p class="connections__error" role="alert">{{ key | translate }}</p>
              }
              <p class="connections__hint">{{ 'pages.settings.connections.howTo' | translate }}</p>
            </form>
          }
        </nb-card-body>
      </nb-card>
    }
  </div>
}
